import React from 'react'

import { useRequest } from '../hooks/request'
import { userGet, userEditPath, userEdit } from '../requests/user'
import { PATHS } from '../constants/paths'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { UserForm } from './UserForm'
import { Loader } from './icons/Loader'
import { CenterStuff } from './common/CenterStuff'
import { useParams } from 'react-router-dom'

const disabledFields = {
  email: true,
}

export const UserEdit = () => {
  const params = useParams()
  const userId = params.id

  const userGetRequest = useRequest({
    request: () => userGet({ params: { id: userId } }),
    start: true,
  })

  const userEditRequest = useRequest({
    request: userEdit,
  })

  if (userGetRequest.state.loading || !userGetRequest.state.data) {
    return (
      <CenterStuff>
        <Loader height={100} />
      </CenterStuff>
    )
  }

  const user = userGetRequest.state.data

  return (
    <>
      <PageTitle tradId="profileFromUser" backLink={PATHS.USER_LIST} backLinkTrad="userList" />
      <PageContent>
        <UserForm
          disabledFields={disabledFields}
          confirmLabel="saveModifications"
          initialValues={user}
          path={userEditPath}
          successMessage="saveModificationsSuccess"
          onSubmit={userEditRequest.fetch}
        />
      </PageContent>
    </>
  )
}
